var defaultStyles = {
  "root": "Base-Modal",
  "mask": "Base-Modal--Mask",
  "modal": "Base-Modal--Modal",
  "header": "Base-Modal--Header",
  "title": "Base-Modal--Title",
  "content": "Base-Modal--Content",
  "footer": "Base-Modal--Footer",
  "close_button": "Base-Modal--CloseButton"
};

export { defaultStyles as default };
